<script>
import utils from '@/util'

export default {
  mounted() {
    utils.deleteTokenCookie()
    this.$router.push('/pages/login')
  },
}
</script>
